import { useState } from 'react';

import Accordion from '@com/shared/ocs/accordion';
import { colorPallete } from '@configs/color-pallete';
import Icon from '@utilities/icon';

type DoctorFAQProps = {
  fullName: string;
  latestSpecialityName: string;
  educationLevelId: number;
};

export default function DoctorFAQ({
  fullName,
  latestSpecialityName,
  educationLevelId,
}: DoctorFAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  function getEducationLevelTitle(id: number): string {
    switch (id) {
      case 1:
        return 'کارشناسی';
      case 2:
        return 'کارشناسی ارشد';
      case 3:
        return 'دکتری تخصصی';
      case 4:
        return 'دکترای حرفه ای';
      case 5:
        return 'تخصص';
      case 6:
        return 'فلوشپ';
      case 7:
        return 'فوق تخصص';
      case 8:
        return 'دکترای تخصصی پژوهشی';
      default:
        return 'دکتری عمومی';
    }
  }

  const faqs = [
    {
      question: `در چه زمینه‌هایی می‌توانم از ${fullName} مشاوره بگیرم؟`,
      answer: `${fullName} ${latestSpecialityName} است و شما می‌توانید در این زمینه از ایشان مشاوره بگیرید`,
      id: 1,
    },
    {
      question: `هزینه‌ی مشاوره با ${fullName} چقدر است؟`,
      answer: `هزینه‌ی مشاوره با ${fullName} با توجه به نوع و مدت زمان مشاوره متفاوت است. بعد از انتخاب نوع مشاوره، هزینه برای شما نمایش داده می‌شود.`,
      id: 2,
    },
    {
      question: `آیا امکان دریافت نسخه‌ی الکترونیک در مشاوره‌ی آنلاین وجود دارد؟`,
      answer: `بله. پس از بررسی‌های لازم توسط پزشک، در صورت نیاز نسخه‌ی آنلاین برای شما صادر می‌شود تا روند درمان کامل و بدون وقفه ادامه پیدا کند.`,
      id: 3,
    },
    {
      question: `تخصص ${fullName} چیست؟`,
      answer: `تحصیلات ${fullName} ${getEducationLevelTitle(educationLevelId)} است.`,
      id: 4,
    },
  ];

  return (
    <section className="w-full max-w-2xl mx-auto p-4">
      <h2 className="text-Label/Medium mb-4">سوالات متداول</h2>

      <div className="space-y-3">
        {faqs.map((faq) => (
          <div key={faq.id} className="border-b border-gray-200">
            <button
              onClick={() => setOpenIndex(openIndex === faq.id ? null : faq.id)}
              className="w-full p-3 flex justify-between text-right"
            >
              <span className="text-Label/Medium text-content-primary">
                {faq.question}
              </span>
              <Icon
                name={openIndex === faq.id ? 'ChevronUp' : 'ChevronDown'}
                width={1.5}
                height={1.5}
                fill={colorPallete.content?.primary}
              />
            </button>

            <Accordion isOpen={openIndex === faq.id}>
              <div className="p-3 text-sm text-gray-600">{faq.answer}</div>
            </Accordion>
          </div>
        ))}
      </div>
    </section>
  );
}
